var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('input', {
    attrs: {
      "id": "inputFile",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.previewImage
    }
  }), _vm.imageData.length > 0 ? _c('div', {
    staticClass: "upload"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageData,
      "alt": ""
    }
  })]) : _vm._e(), _c('label', {
    attrs: {
      "for": "inputFile"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.inputName) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }